
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Simulate form submission
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-900 mb-4">
            Ready to Move Forward?
          </h2>
          <p className="text-lg text-gray-600 font-light">
            Free 30-minute consultation to discuss your goals.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-0 py-3 text-gray-900 placeholder-gray-500 border-0 border-b border-gray-300 focus:border-gray-700 focus:outline-none bg-transparent font-light"
                />
              </div>
              
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-0 py-3 text-gray-900 placeholder-gray-500 border-0 border-b border-gray-300 focus:border-gray-700 focus:outline-none bg-transparent font-light"
                />
              </div>
              
              <div>
                <textarea
                  name="message"
                  rows={4}
                  placeholder="Tell us about your project"
                  value={formData.message}
                  onChange={handleInputChange}
                  maxLength={500}
                  className="w-full px-0 py-3 text-gray-900 placeholder-gray-500 border-0 border-b border-gray-300 focus:border-gray-700 focus:outline-none bg-transparent resize-none font-light"
                />
                <div className="text-right text-xs text-gray-400 mt-1">
                  {formData.message.length}/500
                </div>
              </div>
              
              <div className="pt-4">
                <Button 
                  type="submit" 
                  variant="primary" 
                  size="lg" 
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Get Started'}
                </Button>
              </div>
              
              {submitStatus === 'success' && (
                <div className="text-green-600 text-sm font-light">
                  Thank you! We'll get back to you within 24 hours.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="text-red-600 text-sm font-light">
                  Something went wrong. Please try again.
                </div>
              )}
            </form>
          </div>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-3">Contact Information</h3>
              <div className="space-y-3 text-gray-600 font-light">
                <p>hello@strategyconsulting.com</p>
                <p>+1 (555) 123-4567</p>
                <p>New York, NY</p>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-3">Office Hours</h3>
              <div className="space-y-2 text-gray-600 font-light">
                <p>Monday - Friday: 9:00 AM - 6:00 PM EST</p>
                <p>Saturday: 10:00 AM - 2:00 PM EST</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
